import { BrowserProvider, JsonRpcProvider } from "ethers";
import { SEPOLIA_CHAIN_ID, SEPOLIA_RPC_URL } from "./contracts";

const RPC_PROBE_TIMEOUT_MS = 5000;

function withTimeout(promise, ms) {
  return new Promise((resolve, reject) => {
    const t = setTimeout(() => reject(new Error("RPC timeout")), ms);
    promise.then(
      (v) => {
        clearTimeout(t);
        resolve(v);
      },
      (e) => {
        clearTimeout(t);
        reject(e);
      }
    );
  });
}

/**
 * Prefer MetaMask/injected provider for reads when on Sepolia (no CORS issues).
 * HTTP fallbacks: fast, browser-friendly endpoints first; rpc.sepolia.org last (often slow/522/CORS).
 */
export async function getSepoliaReadProvider() {
  if (typeof window !== "undefined" && window.ethereum) {
    const bp = new BrowserProvider(window.ethereum);
    const net = await bp.getNetwork();
    if (Number(net.chainId) === SEPOLIA_CHAIN_ID) {
      return bp;
    }
  }

  const urls = [
    process.env.REACT_APP_SEPOLIA_RPC_URL,
    SEPOLIA_RPC_URL,
    "https://ethereum-sepolia.publicnode.com",
    "https://1rpc.io/sepolia",
    "https://rpc.sepolia.org",
  ].filter((u, i, a) => u && a.indexOf(u) === i);

  let lastErr;
  for (const url of urls) {
    try {
      const p = new JsonRpcProvider(url, SEPOLIA_CHAIN_ID);
      await withTimeout(p.getBlockNumber(), RPC_PROBE_TIMEOUT_MS);
      return p;
    } catch (e) {
      lastErr = e;
    }
  }
  throw lastErr || new Error("Unable to reach Sepolia");
}
